export default "__VITE_ASSET__BL4s0_b5__"